import pako from 'pako';

export const compressData = (data) => {
  const compressed = pako.deflate(JSON.stringify(data));

  return compressed;
};
